import { TemplateElement } from '@webtides/element-js';

import template from './filter-specs.template';
import SpecFilterEvents from '../spec-filter/SpecFilterEvents';
import '../../../../legacy-library/webcomponents/_form/dropdown-control/dropdown-control';
import styles from './_filter-specs.css';

export default class FilterSpecs extends TemplateElement {
    constructor(options = {}) {
        super(Object.assign({ shadowRender: false, styles: [styles] }, options));
    }

    properties() {
        return {
            filter: [],
            filterMeta: [],
            isOpen: false,
            activeIndex: -1,
        };
    }

    watch() {
        return {
            isOpen: isOpen => {
                if (!isOpen) {
                    // We closed the filter which means, we need to update the filters.
                    this.dispatch(SpecFilterEvents.APPLY_FILTERS, {}, true);
                    this.activeIndex = -1;
                } else {
                    this.dispatch(SpecFilterEvents.OPEN_FILTER, {}, true);
                }
            },
            filter: () => {
                this.querySelectorAll('[filter]').forEach(filter => {
                    filter.requestUpdate();
                });
            },
        };
    }

    events() {
        return {
            '[open-filter]': {
                click: ev => {
                    const clickIndex = Number(ev.currentTarget.dataset.index);
                    if (this.isOpen && clickIndex === this.activeIndex) {
                        this.isOpen = false;
                        return;
                    }
                    this.activeIndex = Number(ev.currentTarget.dataset.index);
                    this.isOpen = true;

                    const activeGroup = this.$refs.filterGroup[this.activeIndex];
                    activeGroup.classList.toggle(
                        'filter-content-right',
                        activeGroup.getBoundingClientRect().left > window.innerWidth / 2
                    );
                },
            },
            this: {
                [SpecFilterEvents.APPLY_SINGLE_FILTER]: ({ detail }) => {
                    this.querySelectorAll('.filter-content').forEach(filter => {
                        this.activeIndex = -1;
                    });

                    this.isOpen = false;
                },
            },
        };
    }

    get many() {
        return this.filter.length > 4;
    }

    template() {
        return template(this);
    }
}
